import {
  FilledInputProps,
  InputProps,
  OutlinedInputProps,
} from '@mui/material';
import { ReactNode } from 'react';
import { InternationalTaxRate } from 'services/integrations/xero';
import { ChannelTaxType } from 'services/taxRates';

export interface InternationalTaxRatesProps {
  accountingType: string;
  label?: string;
  optionsFilter?: (taxRate: InternationalTaxRate) => boolean;
  selectedOptionCallback: (
    value: InternationalTaxRate,
    index: number | undefined
  ) => boolean;
  children?: ReactNode;
  index?: number;
  selectedValue?: InternationalTaxRate | null;
  dataQa?: string;
  error?: boolean;
  additionalInputProps?:
    | Partial<InputProps>
    | Partial<FilledInputProps>
    | Partial<OutlinedInputProps>;
  disabled: boolean;
  setSelectedValue: React.Dispatch<
    React.SetStateAction<InternationalTaxRate | null>
  >;
  activeTaxRateId?: number | null;
  helperText?: string;
}
export interface TaxRateMappingModalProps {
  open: boolean;
  onClose: () => void;
}
export interface TaxMappingRates {
  taxId: number;
  channelsTaxRate: ChannelTaxRate;
}
export interface ChannelTaxRate {
  name: string;
  rate: number;
  code: string;
  taxType: ChannelTaxType;
}
export enum routes {
  AddNewTaxRates = '/setup/tax-rates?activeId=-1',
}
export interface TaxRateMappingModalProps {
  open: boolean;
  onClose: () => void;
}
export interface TaxMappingRates {
  taxId: number;
  channelsTaxRate: ChannelTaxRate;
}
export interface ChannelTaxRate {
  name: string;
  rate: number;
  code: string;
  taxType: ChannelTaxType;
}
